<div class="login-container">
  <!-- Left Panel - Brand Section -->
  <div class="brand-panel">
    <div class="brand-content">
      <div class="brand-logo">Sudocad.io</div>
      <h2 class="brand-tagline">Eğitim Takip ve Koçluk Sistemi</h2>
      <p class="brand-description">
        Güçlü raporlama araçları ve akıllı analizlerle eğitim süreçlerinizi optimize edin.
      </p>

      <div class="brand-illustration">
        <i class="fas fa-graduation-cap illustration-icon"></i>
      </div>

      <ul class="features-list">
        <li class="feature-item">
          <div class="feature-icon">
            <i class="fas fa-bolt"></i>
          </div>
          <span class="feature-text">Hızlı ve güvenilir altyapı</span>
        </li>
        <li class="feature-item">
          <div class="feature-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <span class="feature-text">Gelişmiş analiz ve raporlama</span>
        </li>
        <li class="feature-item">
          <div class="feature-icon">
            <i class="fas fa-shield-halved"></i>
          </div>
          <span class="feature-text">Kurumsal düzeyde güvenlik</span>
        </li>
      </ul>
    </div>
  </div>

  <!-- Right Panel - Login Form -->
  <div class="login-panel">
    <div class="login-form-container">
      <!-- Mobile Header -->
      <div class="mobile-header">
        <div class="mobile-logo">Sudocad.io</div>
      </div>

      <div class="form-header">
        <h1>Hoş Geldiniz</h1>
        <p>Hesabınıza giriş yapın</p>
      </div>

      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label class="form-label" for="loginEmail">E-posta Adresi</label>
          <div class="input-wrapper">
            <input
              type="email"
              id="loginEmail"
              class="form-input"
              placeholder="ornek@sirket.com"
              formControlName="email"
            >
            <i class="fas fa-envelope input-icon"></i>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="loginPassword">Şifre</label>
          <div class="input-wrapper">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="loginPassword"
              class="form-input"
              placeholder="Şifrenizi girin"
              formControlName="password"
            >
            <i class="fas fa-lock input-icon"></i>
            <button type="button" class="password-toggle" (click)="showPassword = !showPassword">
              <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
        </div>

        <div class="form-options">
          <label class="checkbox-wrapper">
            <input type="checkbox" class="checkbox-input" formControlName="rememberMe">
            <span class="checkbox-label">Beni Hatırla</span>
          </label>
          <a routerLink="/account/forgot-password" class="forgot-link">Şifremi Unuttum</a>
        </div>

        <button type="submit" class="btn-login" [disabled]="isLoading">
          <span *ngIf="!isLoading">Giriş Yap</span>
          <span *ngIf="isLoading"><i class="fas fa-spinner fa-spin"></i> Giriş yapılıyor...</span>
        </button>
      </form>

      <div class="divider">
        <div class="divider-line"></div>
        <span class="divider-text">veya</span>
        <div class="divider-line"></div>
      </div>

      <button type="button" class="btn-google" (click)="loginWithGoogle()">
        <i class="fab fa-google"></i>
        Google ile Giriş Yap
      </button>

      <div class="form-footer">
        <p>Hesabınız yok mu? <a routerLink="/account/register">Kayıt Olun</a></p>
      </div>
    </div>
  </div>
</div>
